import styled from 'styled-components';

export const CompanyHomeContainer = styled.main`
  /* border: 3px solid rebeccapurple; */
  height: 100vh;
  width: 80%;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.s};
  margin: 0 auto;
  header {
    text-align: center;
  }
  h3 {
    font-size: ${({ theme }) => theme.spacing.xl};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
  .company-logo {
    /* border: 5px solid red; */
    height: 100px;
    width: 200px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CompanyNav = styled.div`
  /* border: 2px solid blue; */
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
  a {
    /* border: 1px solid red; */
    color: ${({ theme }) => theme.colors.grey4};
  }
  a:hover {
    transition: 1s;
    color: ${({ theme }) => theme.colors.orange2};
  }
  @media screen and (max-width: 768px) {
    gap: ${({ theme }) => theme.spacing.xxs};
    a {
      margin-bottom: ${({ theme }) => theme.spacing.s};
      width: 30%;
      text-align: center;
      padding: ${({ theme }) => theme.spacing.xs};
    }
  }
`;

export const CompanyDataDiv = styled.div`
  /* border: 2px solid green; */
  margin-top: ${({ theme }) => theme.spacing.m};
  p {
    /* border: 1px solid red; */
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey4};
    margin-top: ${({ theme }) => theme.spacing.s};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey1};
    padding: ${({ theme }) => theme.spacing.xs};
  }
  p strong {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey5};
    margin-right: 8px;
  }
  img {
    max-width: 150px;
    height: auto;
    margin-bottom: 16px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.grey2};
  }
  h4 {
    /* border: 1px solid orange; */
    background-color: ${({ theme }) => theme.colors.grey25};
    padding: ${({ theme }) => theme.spacing.xs};
  }
  h5 {
    /* border: 1px solid blue; */
    background-color: ${({ theme }) => theme.colors.offWhite};
    margin-top: ${({ theme }) => theme.spacing.s};
    padding: ${({ theme }) => theme.spacing.xs};
    font-weight: bold;
  }
`;
